"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeDatasheetMap = exports.eqSet = void 0;
const without_1 = __importDefault(require("lodash/without"));
const core_1 = require("../core");
function eqSet(as, bs) {
    if (as.size !== bs.size) {
        return false;
    }
    for (const a of as)
        if (!bs.has(a)) {
            return false;
        }
    return true;
}
exports.eqSet = eqSet;
const subscribeDatasheetMap = (store, datasheetService) => {
    let datasheetIdSet = new Set();
    let datasheetMap = {};
    function linkLookUpField(datasheetId, visitedDst) {
        const _visitedDst = visitedDst || new Set();
        if (_visitedDst.has(datasheetId)) {
            return;
        }
        const state = store.getState();
        const datasheet = core_1.Selectors.getDatasheet(state, datasheetId);
        const shareId = state.pageParams.shareId;
        const formId = state.pageParams.formId;
        if (shareId && formId) {
            return;
        }
        _visitedDst.add(datasheetId);
        if (!datasheet) {
            console.log(`go go go load the data of (${datasheetId})`);
            return; //store.dispatch(StoreActions.fetchDatasheet(datasheetId) as any);
        }
        const fieldMap = core_1.Selectors.getFieldMap(state, datasheetId);
        const lookUpFields = Object.values(fieldMap).filter(field => field.type === core_1.FieldType.LookUp);
        let index = 1;
        const findNextLookUpField = (field, fieldMap, visitedField) => {
            const _visitedField = visitedField || new Set();
            if (_visitedField.has(field.id)) {
                return;
            }
            _visitedField.add(field.id);
            // The actual fields of this table lookup query.
            const lookUpTargetField = core_1.Field.bindModel(field).getLookUpTargetField();
            if (!lookUpTargetField) {
                // The foreign key data for this table is not loaded.
                const foreignField = fieldMap[field.property.relatedLinkFieldId];
                if (foreignField && foreignField.type === core_1.FieldType.Link) {
                    console.log(`2.${index}.1 "${field.name}" the data of the queried table (${foreignField.property.foreignDatasheetId}) is not loaded`);
                    linkLookUpField(foreignField.property.foreignDatasheetId, _visitedDst);
                }
            }
            else {
                console.log(`2.${index}.1 "${field.name}" the actual field of the query is: 「${lookUpTargetField.name}」`, { lookUpTargetField });
            }
            // lookup lookup le lookup
            // The lookup of this table looks up another lookup field of the foreign key table.
            if (lookUpTargetField && lookUpTargetField.type === core_1.FieldType.LookUp) {
                console.log(`2.${index}.2 "${lookUpTargetField.name}" is also a lookup field`);
                findNextLookUpField(lookUpTargetField, fieldMap, _visitedField);
            }
        };
        for (const field of lookUpFields) {
            findNextLookUpField(field, fieldMap);
            index++;
        }
    }
    return store.subscribe(function datasheetMapChange() {
        var _a;
        const state = store.getState();
        if (!((_a = datasheetService.instance) === null || _a === void 0 ? void 0 : _a.checkRoomExist())) {
            return;
        }
        const previousDatasheetMap = datasheetMap;
        datasheetMap = state.datasheetMap;
        const previousDatasheetIdSet = datasheetIdSet;
        if (previousDatasheetMap === datasheetMap) {
            return;
        }
        datasheetIdSet = new Set(Object.keys(datasheetMap).filter(id => {
            var _a;
            return Boolean(datasheetMap[id].datasheet) && !((_a = datasheetMap[id].datasheet) === null || _a === void 0 ? void 0 : _a.preview);
        }));
        if (eqSet(previousDatasheetIdSet, datasheetIdSet)) {
            return;
        }
        // Check if new datasheet data is loaded, and if so, establish a socket via resourceService.
        const currentDatasheetIds = Array.from(datasheetIdSet);
        const collaEngineKeys = datasheetService.instance.getCollaEngineKeys();
        const entityDatasheetIds = [...collaEngineKeys];
        const diff = (0, without_1.default)(currentDatasheetIds, ...entityDatasheetIds);
        console.log('create datasheetService', diff);
        diff.forEach(id => {
            datasheetService.instance.createCollaEngine(id, core_1.ResourceType.Datasheet);
        });
        // Why should I clear the cache of formula parsing? See also:
        // https://www.notion.so/Debug-2021-03-29-a5a756dc2c9640e2957103c9bb5eeebd#bd1ef9866f504b8c85be4c27088f9ada.
        core_1.ExpCache.clearAll();
        diff.forEach(id => {
            var _a;
            linkLookUpField(id);
            if (datasheetMap[id] && ((_a = datasheetMap[id]) === null || _a === void 0 ? void 0 : _a.datasheet)) {
                const fieldMap = datasheetMap[id].datasheet.snapshot.meta.fieldMap;
                datasheetService.instance.computeRefManager.computeRefMap(fieldMap, id, state);
            }
            // console.log('refMap', computeRefManager.refMap);
        });
    });
};
exports.subscribeDatasheetMap = subscribeDatasheetMap;
